<template>
  <div class="main_area" style="min-height: 630px">
    <div class="type_menu_area">
      <div class="type_menu wallet_menu menu_area_bg">
        <div class="type_menu_item active">
          <a><span>存款</span></a>
        </div>
        <div class="type_menu_item">
          <a @click="$parent.goNav('/withdraw')"><span>取款</span></a>
        </div>
        <div class="type_menu_item">
          <a @click="$parent.goNav('/transfer')"><span>转账</span></a>
        </div>
      </div>
    </div>
    <div class="detail_area">
      <div class="wallet channel_item_area">
        <div class="channel_group">
          <div class="channel_items layout">
            <a @click="showPay(0)" v-if="payWayList.usdt == 1">
              <div class="block_content channel_item" data-id="5">
                <div>
                  <div class="icon_circle_card recommended mr-2"><img alt="" src="/static/image/1612269904-6-数字货币-图标.png" /></div>
                </div>
                <div>
                  <div>数字货币 <span class="recommended_tag">推荐</span></div>
                  <div class="promo_deposit">USDT钱包充值</div>
                </div>
                <div><img alt="" src="/static/image/arrow_right.png" /></div>
              </div>
            </a>
            <a @click="showPay(1)" v-if="payWayList.card == 1">
              <div class="block_content channel_item" data-id="4">
                <div>
                  <div class="icon_circle_card recommended mr-2"><img alt="" src="/static/image/1610265055-4-pay_unionpay.png" /></div>
                </div>
                <div>
                  <div>银联</div>
                  <div class="promo_deposit">银行卡支付</div>
                </div>
                <div><img alt="" src="/static/image/arrow_right.png" /></div>
              </div>
            </a>
            <a @click="showPay(2)" v-if="payWayList.wechat == 1">
              <div class="block_content channel_item" data-id="1">
                <div>
                  <div class="icon_circle_card recommended mr-2"><img alt="" src="/static/image/1610269965-6-微信.png" /></div>
                </div>
                <div>
                  <div>微信 <span class="recommended_tag">推荐</span></div>
                  <div class="promo_deposit">可扫码支付</div>
                </div>
                <div><img alt="" src="/static/image/arrow_right.png" /></div>
              </div>
            </a>
            <a @click="showPay(3)" v-if="payWayList.alipay == 1">
              <div class="block_content channel_item" data-id="2">
                <div>
                  <div class="icon_circle_card recommended mr-2"><img alt="" src="/static/image/1610264635-6-pay_alipay.png" /></div>
                </div>
                <div>
                  <div>支付宝 <span class="recommended_tag">推荐</span></div>
                  <div class="promo_deposit">可扫码支付</div>
                </div>
                <div><img alt="" src="/static/image/arrow_right.png" /></div>
              </div>
            </a>
            <a @click="$parent.openKefu">
              <div class="block_content channel_item" data-id="4">
                <div>
                  <div class="icon_circle_card recommended mr-2"><img alt="" src="/static/image/1612080482-6-apptransfer_recommend.png" /></div>
                </div>
                <div>
                  <div>人工充值</div>
                  <div class="promo_deposit">若其他支付方式失败，建议您使用人工充值功能，由专人客服引导您进行充值</div>
                </div>
                <div><img alt="" src="/static/image/arrow_right.png" /></div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- 数值钱包 -->
    <div class="modal_bottom" id="payment_bottoms0">
      <div class="modal_dialog payment_dialog">
        <div class="modal_content">
          <div class="modal_header">
            <div class="modal_dismiss" data-dismiss="bottommodal"></div>
            <div class="w-100 payment_channel_title">
              <!-- <div class="payment_icon channel_icon"><img alt="" src="/static/image/gateway_qrcode_b.png"></div>  -->
              <span class="modal-title">虚拟币存款 <span class="subtitle"></span></span>
            </div>
          </div>
          <div class="modal_body">
            <div data-v-0bf24c42="" class="textbox_content">
              <input data-v-0bf24c42="" v-model="amount" type="text" name="security_pin" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`" id="security_pins" class="pin" />
            </div>
            <br />
            <div data-v-0bf24c42="" class="textbox_content">
              <select name="" v-model="meyXi" id="" class="fn binput" @change="getPayRange">
                <option :value="null" disabled selected>请选择钱包协议</option>
                <option value="ERC20">ERC20</option>
                <option value="TRC20">TRC20</option>
              </select>
            </div>

            <div class="deposit_bottom_container default reload_bottom">
              <div class="block_content">
                <table>
                  <tbody>
                    <tr>
                      <td><span class="deposit_actual_amount_label">实际到账</span></td>
                      <td rowspan="2" id="actual_amount">≈ {{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }} USDT</td>
                    </tr>
                    <tr class="deposit_hints2">
                      <td>参考汇率：{{ $store.state.userInfo.usdtrate }}</td>
                    </tr>
                    <tr class="deposit_hints2">
                      <td>温馨提示：请注意充值方式。</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="textbox_content">
                <button id="payment" class="btn w-100 btn_action active" @click="payTest">确定充值</button>
                <button id="payment" class="btn w-100 btn_action" @click="close" style="margin-top: 10px">取消</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 银行卡 -->
    <div class="modal_bottom" id="payment_bottoms1">
      <div class="modal_dialog payment_dialog">
        <div class="modal_content">
          <div class="modal_header">
            <div class="modal_dismiss" data-dismiss="bottommodal"></div>
            <div class="w-100 payment_channel_title">
              <!-- <div class="payment_icon channel_icon"><img alt="" src="/static/image/gateway_qrcode_b.png"></div>  -->
              <span class="modal-title">银行卡存款 <span class="subtitle"></span></span>
            </div>
          </div>
          <div class="JoiHTIGs">
            <div class="_1lgxzaTd VnPYo1MB _3jiVkBQ9" v-for="(item, index) in cardLis" :key="index">
              <p style="font-size: 10px; line-height: 1; color: #fff">收款银行：{{ item.bank_data.bank_name }}</p>
              <p style="font-size: 10px; line-height: 1; color: #fff">账号：{{ item.bank_no }} <img @click="doCopy(item.bank_no)" style="width: 20px; float: right" src="/static/image/clongicon.png" alt="" /></p>
              <p style="font-size: 10px; line-height: 1; color: #fff">户名：{{ item.bank_owner }} <img @click="doCopy(item.bank_owner)" style="width: 20px; float: right" src="/static/image/clongicon.png" alt="" /></p>
              <p style="font-size: 10px; line-height: 1.2; color: #fff">银行地址：{{ item.bank_address }}</p>
            </div>
          </div>
          <div class="modal_body">
            <div data-v-0bf24c42="" class="textbox_content">
              <select name="" v-model="bankBox.bank" id="" class="fn binput">
                <option :value="null" disabled selected>请选择银行</option>
                <option :value="item.id" v-for="(item, index) in banklist" :key="index">{{ item.bank_name }}</option>
              </select>
            </div>
            <br />

            <div data-v-0bf24c42="" class="textbox_content">
              <input data-v-0bf24c42="" v-model="bankBox.bank_owner" type="text" name="security_pin" placeholder="汇款姓名" id="security_pins" class="pin" />
            </div>
            <br />

            <div data-v-0bf24c42="" class="textbox_content">
              <input data-v-0bf24c42="" v-model="bankBox.bank_no" type="text" name="security_pin" placeholder="汇款卡号" id="security_pins" class="pin" />
            </div>
            <br />

            <div data-v-0bf24c42="" class="textbox_content">
              <input data-v-0bf24c42="" v-model="bankBox.bank_address" type="text" name="security_pin" placeholder="开户行" id="security_pins" class="pin" />
            </div>
            <br />

            <div data-v-0bf24c42="" class="textbox_content">
              <input data-v-0bf24c42="" v-model="amount" type="text" name="security_pin" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`" id="security_pins" class="pin" />
            </div>

            <div class="deposit_bottom_container default reload_bottom">
              <div class="block_content">
                <table>
                  <tbody>
                    <tr class="deposit_hints2">
                      <td>温馨提示：请注意充值方式。</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="textbox_content">
                <button id="payment" class="btn w-100 btn_action active" @click="payTest">确定充值</button>
                <button id="payment" class="btn w-100 btn_action" @click="close" style="margin-top: 10px">取消</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 微信充值 -->
    <div class="modal_bottom" id="payment_bottoms2">
      <div class="modal_dialog payment_dialog">
        <div class="modal_content">
          <div class="modal_header">
            <div class="modal_dismiss" data-dismiss="bottommodal"></div>
            <div class="w-100 payment_channel_title">
              <!-- <div class="payment_icon channel_icon"><img alt="" src="/static/image/gateway_qrcode_b.png"></div>  -->
              <span class="modal-title">微信支付 <span class="subtitle"></span></span>
            </div>
          </div>
          <div class="modal_body">
            <div data-v-0bf24c42="" class="textbox_content">
              <input data-v-0bf24c42="" v-model="amount" type="text" name="security_pin" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`" id="security_pins" class="pin" />
            </div>
            <div class="deposit_bottom_container default reload_bottom">
              <div class="block_content">
                <table>
                  <tbody>
                    <tr class="deposit_hints2">
                      <td>温馨提示：请注意充值方式。</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="textbox_content">
                <button id="payment" class="btn w-100 btn_action active" @click="payTest">确定充值</button>
                <button id="payment" class="btn w-100 btn_action" @click="close" style="margin-top: 10px">取消</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付寶 -->
    <div class="modal_bottom" id="payment_bottoms3">
      <div class="modal_dialog payment_dialog">
        <div class="modal_content">
          <div class="modal_header">
            <div class="modal_dismiss" data-dismiss="bottommodal"></div>
            <div class="w-100 payment_channel_title">
              <!-- <div class="payment_icon channel_icon"><img alt="" src="/static/image/gateway_qrcode_b.png"></div>  -->
              <span class="modal-title">支付宝支付 <span class="subtitle"></span></span>
            </div>
          </div>
          <div class="modal_body">
            <div data-v-0bf24c42="" class="textbox_content">
              <input data-v-0bf24c42="" v-model="amount" type="text" name="security_pin" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`" id="security_pins" class="pin" />
            </div>
            <div class="deposit_bottom_container default reload_bottom">
              <div class="block_content">
                <table>
                  <tbody>
                    <tr class="deposit_hints2">
                      <td>温馨提示：请注意充值方式。</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="textbox_content">
                <button id="payment" class="btn w-100 btn_action active" @click="payTest">确定充值</button>
                <button id="payment" class="btn w-100 btn_action" @click="close" style="margin-top: 10px">取消</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 没有绑定卡片 -->
    <div v-if="userbank.length == 0 && userUSD.length == 0" :class="true ? 'modal fade normal_announcement show' : 'modal fade normal_announcement'"  id="normal_announcement_popout" aria-modal="true" style="display: block">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header border_radius_top">
            <div class="font-weight-bold text-left w-100" style="font-size: 17px">温馨提示</div>
          </div>
          <div class="modal-body border_radius_bottom">
            <div>您还为绑定任何钱包卡片，请前往绑定！</div>
            <div @click="$parent.goNav('/bankCard')" class="textbox_content" style="padding-bottom: 20px; margin-top: 20px;"><button  data-v-3d893316="" data-v-7c9a7985="" id="payment" class="btn w-100 btn_action active">前往绑定</button> <!----></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'wallet',
  data() {
    return {
      type: 1,
      meyXi: 'ERC20', //qian
      amount: null,
      cardLis: [],
      banklist: [],
      cardInfo: { bank: null },
      bankBox: { bank: null },
      pay_way: 0,
      payWayList: {},
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type;
    }
    that.getPayWay();

    that.getcard();
    that.getBanklist();
  },
  methods: {
    getPayRange() {
      let that = this;
      let type = null;
      //  let pay_way_arr = ['usdt', 'card', 'wxpay', 'alipay'];
      if (that.pay_way == 1) {
        type = 'bank';
      }
      if (that.pay_way == 2) {
        type = 'wechat';
      }
      if (that.pay_way == 3) {
        type = 'alipay';
      }

      if (that.pay_way == 0) {
        if (that.meyXi == 'ERC20') {
          type = 'usdt-erc20';
        }
        if (that.meyXi == 'TRC20') {
          type = 'usdt-trc20';
        }
      }
      // bank/wechat/alipay/usdt-erc20/usdt-trc20/ebpay    min_price max_price
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getPayWay() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.payWayList.rengong = 1;
            let obj = that.payWayList;
            let pay_way_arr = ['usdt', 'card', 'wxpay', 'alipay'];

            for (let i in obj) {
              if (obj[i] == 1) {
                that.pay_way = pay_way_arr.indexOf(i);
                that.hideLoading();
                that.getPayRange();

                return;
              }
            }
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    showPay(type) {
      let that = this;
      this.bankBox = { bank: null };
      this.amount = null;
      let _this = '#payment_bottoms' + type;
      that.pay_way = type;
      that.getPayRange();
      $(_this).addClass('active').addClass('delay');
    },
    close() {
      this.bankBox = { bank: null };
      this.amount = null;
      $('.modal_bottom').removeClass('active');
      setTimeout(function () {
        $('.modal_bottom').removeClass('delay');
      }, 200);
    },
    payTest() {
      let that = this;
      let pay_way_arr = ['usdt', 'bank', 'wxpay', 'alipay'];
      let info = {};

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (pay_way_arr[that.pay_way] == 'bank') {
        info = {
          paytype: pay_way_arr[that.pay_way],
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.$parent.showTost(0, '请输入存款人姓名');
          return;
        }
        if (!info.bank) {
          that.$parent.showTost(0, '请输入银行类型');
          return;
        }

        if (!info.bank_no) {
          that.$parent.showTost(0, '请输入银行卡号');
          return;
        }
        if (!info.bank_address) {
          that.$parent.showTost(0, '请输入银行开户行地址');
          return;
        }
      } else {
        //暂时
        info = {
          paytype: pay_way_arr[that.pay_way],
          amount: that.amount * 1,
        };
      }
      if (pay_way_arr[that.pay_way] == 'usdt') {
        info.catepay = that.meyXi;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (pay_way_arr[that.pay_way] == 'bank') {
              that.$parent.showTost(1, '提交成功，等待后台审核');
              that.bankBox = {};
              that.amount = null;

              that.$parent.hideLoading();
              that.close();
              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.$parent.showTost(1, '正在跳转...');

            const routeData = this.$router.resolve({
              path: '/payInfo',
              query: { deposit_no: res.message },
            });
            that.close();

            window.open(routeData.href, '_blank');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },

    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    showLoading() {
      let that = this;
      that.$parent.showLoading();
    },
    hideLoading() {
      let that = this;
      that.$parent.hideLoading();
    },
    getcard() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;
            that.$parent.hideLoading();
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm);
      let that = this;
      vm.getuseCardlist();
    });
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/announcement_modal.css';

.JoiHTIGs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
._1lgxzaTd[data-v-4c5c1c3e] {
}
.JoiHTIGs ._3jiVkBQ9 {
  margin-bottom: 20px;
}
._1lgxzaTd.VnPYo1MB {
  cursor: pointer;
  width: 100%;
}

._1lgxzaTd {
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  // background-image: url(/static/image/img_cardusdt1-81b6.png);
  background-image: url(/static/image/bg2.c14d2591.png);
}
.JoiHTIGs p {
  margin-bottom: 4px;
}
.modal_content {
  padding-bottom: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/wallet.vue